Element.prototype.gwHide = function(v) {
	this.classList.toggle('hidden', !!v);
};

Element.prototype.gwIsHidden = function(v) {
	return this.classList.contains('hidden');
};

DOMTokenList.prototype.addFromStringList = function(arg) {
	if (arg == null) {
		return;
	}

	let str = String(arg).trim();
	if (str == '') {
		return;
	}

	this.add(...str.split(/\s+/));
};

Object.defineProperty(Element.prototype, 'IShallNotPassUntrustedInputToInnerHTML', Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML'));

Object.defineProperty(Element.prototype, 'innerHTML', {
	set() {
		throw new Error('innerHTML is forbidden, use textContent');
	},

	get() {
		throw new Error('innerHTML is forbidden, use textContent');
	},
});

GW.override(GW.Object, {
	'before:destroy'() {
		Utils.abortAll(this);
	},
});

GW.override(GW.Component, {
	findAncestorProperty(name) {
		let p = this.getParent();
		while (p && !p[name]) {
			p = p.getParent();
		}

		return p ? p[name] : null;
	},
});
